import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, Grid, Tab, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetExamNameData,
  GetStudentAllExamNameData,
} from "../testPrepDashboard/Api/DashboardApi";
import RoundedTabs from "../../components/customTabs/RoundedTabs";
import Examcards from "./components/Examcards";
import Loader from "../../../SAPPages/components/Loader/Loader";
import NoDataAvailabWithNoCardleScreen from "../../components/screens/NoDataAvailabeWithNoCard";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomTextField from "../../components/customFields/CustomTextField";
import SubSectionData from "./components/subSectionData";
import {
  ExamBirfurcationData,
  TestivastudentAllExamData,
} from "../testPrepDashboard/Api/TestivaApi";

export default function MyExamFinalPage() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const defaulExamData = JSON.parse(localStorage.getItem("defaultExamData"));

  const [selectedTab, setSelectedTab] = useState("Mock");
  const [loading, setLoading] = useState(true);
  const [examNameData, setExamNameData] = useState([]);

  const [subModules, setSubModules] = useState([]); // only submodule array
  const [selectedSubTabIndex, setSelectedSubTabIndex] = useState(0);

  const [selectedSubSectionIndex, setSelectedSubSectionIndex] = useState(0);
  const [selectedSubTestTab, setSelectedSubTestTab] = useState(null);

  const [studentAllData, setStudentAllData] = useState([]);
  const [allDataLoading, setAllDataLoading] = useState(false);

  // Fetch main exam data

  // const handleFetchExamNames = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await GetExamNameData({
  //       examType: defaulExamData?.exam_portal_id,
  //       subCat: defaulExamData?.sub_exam_portal_id,
  //     });

  //     if (response.code === 200) {
  //       setExamNameData(response.finalData);
  //     } else {
  //       setExamNameData([]);
  //     }

  //     setLoading(false);
  //   } catch (err) {
  //     setExamNameData([]);
  //     setLoading(false);
  //   }
  // };

  const FetchExamBirfurcationData = async () => {
    try {
      setLoading(true);

      const response = await ExamBirfurcationData(defaulExamData?.sl_no);
      console.log("EBD", response);

      if (response?.status && response?.data?.length > 0) {
        setExamNameData(response.data[0].exam_birfurcation || []);
      } else {
        setExamNameData([]);
      }
    } catch (err) {
      console.log(err);
      setExamNameData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchExamBirfurcationData();
    // handleFetchExamNames();
  }, []);

  // Fetch ALL student exam data

  const handleFetchAllExamNames = async (subModule, questionSpecific) => {
    try {
      setAllDataLoading(true);

      const response = await GetStudentAllExamNameData({
        studentStmId: userId,
        examType: defaulExamData?.exam_portal_id,
        subCat: defaulExamData?.sub_exam_portal_id,
        subModule,
        questionSpecific,
      });

      if (response.code === 200) {
        setStudentAllData(response?.finalData);
      } else {
        setStudentAllData([]);
      }
      setAllDataLoading(false);
    } catch {
      setStudentAllData([]);
      setAllDataLoading(false);
    }
  };

  const handleFetchTestivaAllExamNames = async (
    subModule,
    questionSpecific,
  ) => {
    try {
      setAllDataLoading(true);

      const response = await TestivastudentAllExamData({
        categoryId: defaulExamData?.sl_no,
        subModule,
        questionSpecific,
      });

      console.log("TAE", response);

      if (response?.status) {
        setStudentAllData(response.data || []);
      } else {
        setStudentAllData([]);
      }
    } catch (err) {
      console.log(err);
      setStudentAllData([]);
    } finally {
      setAllDataLoading(false);
    }
  };

  // ======================================================
  // When examNameData loads → set DEFAULT MAIN TAB
  // ======================================================
  useEffect(() => {
    if (examNameData?.length > 0) {
      const firstTab = examNameData[0].module_name;
      handleChange(null, firstTab);
    }
  }, [examNameData]);

  // Handle MAIN TAB change (Mock, Practice, Q-Specific)

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);

    const selectedData = examNameData.find((i) => i.module_name === newValue);

    if (!selectedData) return;

    setSubModules(selectedData.submodule_data || []);

    setSelectedSubTabIndex(0);
    setSelectedSubSectionIndex(0);

    const firstSub = selectedData.submodule_data?.[0];
    setSelectedSubTestTab(firstSub);

    // Normal branch
    if (newValue !== "Question Specific Exam") {
      if (firstSub) {
        handleFetchTestivaAllExamNames(
          firstSub.subModule,
          firstSub.questionSpecific,
        );
      }
      return;
    }

    // Question Specific Exam branch → fetch first sub-section instead
    if (firstSub?.sub_section_data?.length > 0) {
      const firstSubSection = firstSub.sub_section_data[0];
      handleFetchTestivaAllExamNames(
        firstSubSection.subModule,
        firstSubSection.questionSpecific,
      );
    }
  };

  const redirectionLink1 = "/test-prep/performance/purchase-test";
  const handleRedirect = () => {
    localStorage.setItem("testDetails", JSON.stringify(defaulExamData));
    window.open(redirectionLink1, "_blank");
  };

  return (
    <Grid container spacing={2}>
      {/* Header */}
      <Grid
        item
        xs={12}
        sm={6}
        container
        gap={2}
        alignItems="center"
        onClick={() => navigate("/test-prep/performance")}
        sx={{ cursor: "pointer" }}
      >
        <Box width={32}>
          <img src="/newdashboard/Classrom/wishlist.png" alt="Back" />
        </Box>
        <Typography
          fontFamily="Inter"
          fontWeight={400}
          color="#000"
          fontSize="24px"
        >
          My Exam
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6} textAlign="end">
        <Box
          sx={{
            border: "1px solid #E7CEF6",
            px: "16px",
            py: "10px",
            width: "auto",
            borderRadius: "8px",
            background: "#ffffff",
            display: "inline-block",
          }}
        >
          <Typography
            sx={{ fontFamily: "Inter", color: "#572575", fontWeight: 700 }}
          >
            {defaulExamData?.test_type_name}{" "}
            {defaulExamData?.sub_test_type_name && (
              <span style={{ color: "#444444", fontWeight: 400 }}>
                ({defaulExamData?.sub_test_type_name})
              </span>
            )}
          </Typography>
        </Box>
      </Grid>

      {/* TABS */}
      <Grid item xs={12} mt={1}>
        <Card
          sx={{
            boxShadow: "0px 0px 2px 2px #B33B931A",
            p: 2,
            borderRadius: "16px",
          }}
        >
          {loading ? (
            <Loader text="Loading Exam Details..." />
          ) : (
            <TabContext value={selectedTab}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="dynamic tabs"
                  TabIndicatorProps={{ sx: { background: "#572575" } }}
                  sx={{
                    fontSize: "16px !important",
                    fontWeight: 600,
                    "& .MuiTab-root": {
                      fontSize: "16px",
                      fontFamily: "Inter",
                      color: "#444444",
                      fontWeight: 600,
                    },
                    "& .Mui-selected": { color: "#572575 !important" },
                  }}
                >
                  {examNameData?.map((item, i) => (
                    <Tab
                      key={i}
                      label={item.module_name}
                      value={item.module_name}
                    />
                  ))}
                </TabList>
              </Box>

              {examNameData?.map((item, index) => {
                return (
                  <TabPanel key={index} value={item.module_name}>
                    {/* SUBMODULE TABS */}
                    {subModules.length > 1 && (
                      <RoundedTabs
                        tabs={subModules}
                        selected={selectedSubTabIndex}
                        onChange={(e, idx) => {
                          setSelectedSubSectionIndex(0);
                          setSelectedSubTabIndex(idx);
                          const current = subModules[idx];
                          setSelectedSubTestTab(current);

                          // for sub test tab
                          const firstSub = current.sub_section_data?.[0];

                          {
                            selectedTab !== "Question Specific Exam"
                              ? handleFetchTestivaAllExamNames(
                                  current.subModule,
                                  current.questionSpecific,
                                )
                              : handleFetchTestivaAllExamNames(
                                  firstSub?.subModule,
                                  firstSub?.questionSpecific,
                                );
                          }
                        }}
                      />
                    )}

                    {/* QUESTION SPECIFIC → SUB SECTIONS */}
                    <Box mt={2}>
                      {selectedTab === "Question Specific Exam" &&
                        selectedSubTestTab?.sub_section_data?.length > 1 && (
                          <SubSectionData
                            tabs={selectedSubTestTab?.sub_section_data}
                            selected={selectedSubSectionIndex}
                            onChange={(e, idx) => {
                              setSelectedSubSectionIndex(idx);
                              const current =
                                selectedSubTestTab.sub_section_data[idx];

                              handleFetchTestivaAllExamNames(
                                current.subModule,
                                current.questionSpecific,
                              );
                            }}
                          />
                        )}
                    </Box>

                    {/* EXAM CARD DATA */}
                    {allDataLoading ? (
                      <Loader text="Loading Exam Details" height="30vh" />
                    ) : studentAllData?.length > 0 ? (
                      <Examcards
                        exams={studentAllData}
                        subTabName={subModules?.[selectedSubTabIndex]?.name}
                      />
                    ) : (
                      <Grid container mt={2}>
                        <NoDataAvailabWithNoCardleScreen
                          topImage={
                            <img src="/newdashboard/performance/20769812_Sandy_Bus-25_Single-04 1 (1).png" />
                          }
                          text={`You haven’t any ${subModules?.[selectedSubTabIndex]?.name} Exam yet.`}
                          subText="Upgrade your plan to access all question types, instant scoring, and real-time analytics."
                          buttonName="Upgrade Now"
                          buttonIcon={
                            <Icon icon="material-symbols:crown-rounded" />
                          }
                          redirectionLink={handleRedirect}
                        />
                      </Grid>
                    )}
                  </TabPanel>
                );
              })}
            </TabContext>
          )}
        </Card>
      </Grid>
    </Grid>
  );
}
